import type { PayloadAction } from "@reduxjs/toolkit";

import type { ILoadedProducts } from "./models";

export const UPDATE = "loadedProducts/update";
export function updateLoadedProducts(payload: ILoadedProducts): PayloadAction<ILoadedProducts> {
  return {
    type: UPDATE,
    payload,
  };
}
